import { GO_DIRECTIONS, timing, variantForLevel, } from './params';
const FEEDBACK_MS = timing.feedbackMs;
export function makeStimulus(trialIdx, ssdMs, level) {
    const variant = variantForLevel(level);
    const isStop = Math.random() < variant.stopRate;
    const goDirection = GO_DIRECTIONS[Math.floor(Math.random() * GO_DIRECTIONS.length)];
    return {
        trialIdx,
        goDirection,
        isStopTrial: isStop,
        ssdMs: Math.max(50, ssdMs),
        responseWindowMs: variant.responseWindowMs,
    };
}
export function createInhibitionAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        level,
        variant: variantForLevel(level),
        stopActive: false,
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    function settle(picked, stim) {
        if (!resolver)
            return;
        const rt = picked === null ? stim.responseWindowMs : Date.now() - trialStart;
        let correct;
        if (stim.isStopTrial) {
            // Correct si user a inhibé (picked === null).
            correct = picked === null;
        }
        else {
            // Trial Go : correct si tap match direction et dans la fenêtre.
            correct = picked === stim.goDirection;
        }
        const r = resolver;
        resolver = null;
        rejecter = null;
        r({ picked, correct, reactionTimeMs: rt, wasStopTrial: stim.isStopTrial });
    }
    return {
        mount() { },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({
                    subPhase: 'fixation',
                    stim,
                    feedback: null,
                    stopActive: false,
                });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'awaiting_response', stopActive: false });
                    trialStart = Date.now();
                    // Si Stop trial : pose le stop signal après SSD ms.
                    if (stim.isStopTrial) {
                        timers.push(setTimeout(() => {
                            update({ subPhase: 'stop_signal', stopActive: true });
                        }, stim.ssdMs));
                    }
                    // Timeout fenêtre réponse.
                    timers.push(setTimeout(() => {
                        settle(null, stim);
                    }, stim.responseWindowMs));
                }, timing.fixationMs));
            });
        },
        async showFeedback(correct) {
            update({ subPhase: 'feedback', feedback: correct ? 'correct' : 'incorrect' });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti', stopActive: false });
                    resolve();
                }, FEEDBACK_MS));
            });
        },
        pause() { },
        resume() { },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handleDirectionPick(direction) {
            if (state.subPhase !== 'awaiting_response' && state.subPhase !== 'stop_signal')
                return;
            const stim = state.stim;
            if (!stim)
                return;
            // User a tapé. Cancel les autres timers (timeout, stop signal pose).
            clearTimers();
            settle(direction, stim);
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
    };
}
//# sourceMappingURL=adapter.js.map